var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.88V8.16M10.3571 13.26C10.3571 13.4478 10.1972 13.6 10 13.6C9.80276 13.6 9.64286 13.4478 9.64286 13.26M10.3571 13.26C10.3571 13.0722 10.1972 12.92 10 12.92C9.80276 12.92 9.64286 13.0722 9.64286 13.26M10.3571 13.26H9.64286M17.1633 12.1775L12.7582 4.68892C11.8508 3.14637 11.3971 2.3751 10.8075 2.11489C10.2931 1.88786 9.70689 1.88786 9.19247 2.11489C8.60288 2.3751 8.14919 3.14637 7.24181 4.68892L2.83674 12.1775C1.90699 13.7581 1.44212 14.5484 1.50663 15.1977C1.5629 15.764 1.85774 16.2795 2.31732 16.6152C2.8443 17 3.76118 17 5.59493 17H14.4051C16.2388 17 17.1557 17 17.6827 16.6152C18.1423 16.2795 18.4371 15.764 18.4934 15.1977C18.5579 14.5484 18.093 13.7581 17.1633 12.1775Z",
    stroke: "#FD151B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.006e3a7850f1c5dac54d0324244f5272.svg";
export { ForwardRef as ReactComponent };